import { render, staticRenderFns } from "./storeAlerts.vue?vue&type=template&id=d9bb2e12&"
import script from "./storeAlerts.vue?vue&type=script&lang=js&"
export * from "./storeAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports